export enum DependencySuggestionsGroup {
  PORT = 'PORT',
  IP = 'IP'
}

type DependencySuggestionIPAddressInfo = {
  value: string
  connections: number
  discovered_dependency_id: string
}

type DependencySuggestionPort = {
  port: number
  total_connections: number
  ip_addresses: DependencySuggestionIPAddressInfo[]
}

export type DependencySuggestionsGroupByPort = DependencySuggestionPort[]

type DependencySuggestionPortInfo = {
  value: number
  connections: number
  discovered_dependency_id: string
}

type DependencySuggestionIPAddress = {
  ip_address: string
  total_connections: number
  ports: DependencySuggestionPortInfo[]
}

export type DependencySuggestionsGroupByIpAddress =
  DependencySuggestionIPAddress[]
